import { Col, Label, Row } from "reactstrap";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  foodMenuSearch,
  foodPreOrderEventGuestData,
  foodPreOrderEventGuestToFoodMenuItemCreate,
  foodPreOrderEventGuestToFoodMenuItemCreateSuccess,
} from "../../../../../../store/foodPreOederEvent/action";
import Masonry from "react-masonry-css";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import classnames from "classnames";
import "./tabContent.styles.css";
import { toast } from "react-toastify";
import WarnCustomerOfMenuChoice from "../../../../../../Components/popUpComponents/WarnCustomerOfMenuChoice";

import DeleteModal from "../../../../../../Components/Common/DeleteModal";

import StripeTakePayments from "../../../../../../Components/StripeTakePayments";
import LoadingSpinner from "../../../../../../Components/Common/Spinner";

import Select from "react-select";
import {
  getFoodAllergenList,
  getFoodDietTypeList,
} from "../../../../../../store/products/action";

const FoodMenuTab = ({
  foodPreOrderEventDataAPI,
  availableFoodMenu,
  eventUserData,
  helperGetFoodPreOrderEventGuestList,
  branding,
  hideFoodSelectAndConfirm,
  manageGuestFoodOrders,
  foodpreorderevent_data,
}) => {
  const dispatch = useDispatch();
  const params = useParams();

  const [selectedAllergens, setSelectedAllergens] = useState([]);
  const [selectedDietTypes, setSelectedDietTypes] = useState([]);

  const [
    foodAlreadySelectedUpdateSelection,
    setFoodAlreadySelectedUpdateSelection,
  ] = useState(false);

  const [PaymentMethod_Id, setPaymentMethod_Id] = useState("");
  useEffect(() => {
    setPaymentMethod_Id(
      foodPreOrderEventDataAPI?.foodpreorderevent_data?.PaymentMethod_Id
    );
  }, [foodPreOrderEventDataAPI?.foodpreorderevent_data?.PaymentMethod_Id]);

  const FoodPreOrderEvent_Id = useMemo(
    () => eventUserData?.data?.FoodPreOrderEvent_Id,
    [eventUserData?.data?.FoodPreOrderEvent_Id]
  );

  //callback function to create or update food selection
  const handleCreateUpdateFoodSelection = (StripePaymentIntent) => {
    dispatch(
      foodPreOrderEventGuestToFoodMenuItemCreate(
        [
          {
            FoodPreOrderEventGuest_Id: manageGuestFoodOrders
              ? eventUserData.Id
              : eventUserData?.data?.FoodPreOrderEventGuest_Id,
            FoodMenu_Id: activeTab,
            choices: Object.values(foodSelectionChoices).map((item) => {
              return {
                FoodItemToFoodMenuCategory_Id: item?.Id,
                SpecialInstructions: item?.note,
                Quantity: item?.quantity ?? 1,
              };
            }),
            paymentmethod_data: [
              {
                PaymentMethod_Id: PaymentMethod_Id,
                ...(StripePaymentIntent && {
                  StripePaymentIntent: StripePaymentIntent,
                }),
              },
            ],
          },
        ],
        params?.token ?? null
      )
    );
  };

  useEffect(() => {
    if (isEmpty(availableFoodMenu)) return;
    dispatch(
      foodMenuSearch(
        [
          {
            foodmenu_data: {
              // Id: availableFoodMenu?.map((item) => item?.FoodMenu_Id),
              Id: availableFoodMenu?.map((item) => item?.Id),
            },
            ...(foodpreorderevent_data && {
              foodpreorderevent_data: { Id: foodpreorderevent_data },
            }),
          },
        ],
        params?.token ?? null
      )
    );
  }, [availableFoodMenu]);

  useEffect(() => {
    if (!eventUserData?.data?.FoodPreOrderEventGuest_Id) return;
    dispatch(
      foodPreOrderEventGuestData(
        {
          id: eventUserData?.data?.FoodPreOrderEventGuest_Id,
        },
        params?.token ?? null
      )
    );
  }, [eventUserData]);

  const { foodMenuSearchAPI } = useSelector((state) => ({
    foodMenuSearchAPI: state.FoodPreOrderEventReducer.foodMenuSearch,
  }));

  const [activeTab, setActiveTab] = useState("");

  const [foodSelectionAPIConfirmed, setFoodSelectionAPIConfirmed] =
    useState(false);

  const {
    foodPreOrderEventGuestToFoodMenuItemCreateAPI,
    //loading
    foodPreOrderEventGuestToFoodMenuItemCreateLoading,
  } = useSelector((state) => ({
    foodPreOrderEventGuestToFoodMenuItemCreateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventGuestToFoodMenuItemCreate,
    //loading
    foodPreOrderEventGuestToFoodMenuItemCreateLoading:
      state.FoodPreOrderEventReducer
        .foodPreOrderEventGuestToFoodMenuItemCreateLoading,
  }));

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestToFoodMenuItemCreateAPI)) return;
    if (foodPreOrderEventGuestToFoodMenuItemCreateAPI?.status === 200) {
      toast.success(foodPreOrderEventGuestToFoodMenuItemCreateAPI?.message);
      setFoodSelectionAPIConfirmed(true);
      setFoodAlreadySelectedUpdateSelection(true);
      if (manageGuestFoodOrders) {
        helperGetFoodPreOrderEventGuestList();
      }
    } else {
      toast.error(foodPreOrderEventGuestToFoodMenuItemCreateAPI?.message);
    }
    setEnableStripeCheckout(false);
    dispatch(foodPreOrderEventGuestToFoodMenuItemCreateSuccess([]));
  }, [foodPreOrderEventGuestToFoodMenuItemCreateAPI]);

  const [foodSelectionChoices, setFoodSelectionChoices] = useState([]);
  console.log("foodSelectionChoices", foodSelectionChoices);
  const { foodPreOrderEventGuestDataAPI, foodPreOrderEventGuestDataLoading } =
    useSelector((state) => ({
      foodPreOrderEventGuestDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestData,
      foodPreOrderEventGuestDataLoading:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDataLoading,
    }));

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDataAPI)) return;
    if (foodPreOrderEventGuestDataAPI?.status === 200) {
      // map trough foodPreOrderEventGuestDataAPI?.choices and add to foodSelectionChoices
      let choices = {};
      foodPreOrderEventGuestDataAPI?.choices?.map((item) => {
        choices = {
          ...choices,
          [item?.FoodItemToFoodMenuCategory_Id]: {
            quantity: item?.Quantity,
            note: item?.SpecialInstructions,
            Id: item?.FoodItemToFoodMenuCategory_Id,
            // FoodMenuType_Id: item?.FoodMenuType_Id,
            FoodMenuCategory_Id: item?.FoodMenuCategory_Id,
            showNote: !!item?.SpecialInstructions,
            FoodMenuType_Id: item?.FoodMenuType_Id,
            FlagExclusiveMenuSelection: item?.FlagExclusiveMenuSelection,
            FoodMenu_Id: item?.FoodMenu_Id,
          },
        };
      });
      if (
        foodPreOrderEventGuestDataAPI?.choices?.length > 0 &&
        !manageGuestFoodOrders
      ) {
        setFoodAlreadySelectedUpdateSelection(true);
      } else {
        setFoodAlreadySelectedUpdateSelection(false);
      }
      setFoodSelectionChoices(choices);
      setActiveTab();
    }
  }, [foodPreOrderEventGuestDataAPI]);

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDataAPI)) return;
    if (isEmpty(foodMenuSearchAPI)) return;
    setActiveTab(
      foodPreOrderEventGuestDataAPI?.foodpreordereventguest_data?.FoodMenu_Id ??
        foodMenuSearchAPI?.foodmenu_list[0]?.Id
    );
  }, [foodPreOrderEventGuestDataAPI, foodMenuSearchAPI]);

  const [tempSelectedItem, setTempSelectedItem] = useState(null);
  const handleFoodSelectionChoices = (item, categoryItem, topMenuItem) => {
    const HelperSetFoodSelection = () => {
      setFoodSelectionChoices({
        ...foodSelectionChoices,
        [item?.Id]: {
          ...item,
          FoodMenuCategory_Id: categoryItem?.FoodMenuCategory_Id,
          quantity: 1,
          FoodMenuType_Id: topMenuItem?.FoodMenuType_Id,
          FlagExclusiveMenuSelection: topMenuItem?.FlagExclusiveMenuSelection,
          FoodMenu_Id: topMenuItem?.Id,
        },
      });
    };

    const HelperHandlePopUpAboutSwitchingMenu = () => {
      setTabId(topMenuItem?.Id);
      setCurrentTopMenuItem(topMenuItem);
      setWarningCustomerOfMenuChoice(true);
      setTempSelectedItem(item);
    };
    // add remove item
    // add categoryItem.FoodMenuCategory_Id to item
    if (foodSelectionChoices?.[item?.Id]) {
      // if item is already in foodSelectionChoices remove it set to deleteSelectedfoodItem and open modal
      setDeleteSelectedfoodItem(item?.Id);
      setDeleteSelectedChoiceModal(true);
    } else {
      // First Check if we have any of our food selections same type as the topMenuItem type
      const TopMenuItemType = topMenuItem?.FoodMenuType_Id;
      const TopMenuItemExclusive =
        topMenuItem?.FlagExclusiveMenuSelection === "1"; // 1 is exclusive 0 is not exclusive

      const foodSelectionChoicesArray = Object.values(foodSelectionChoices);

      //if the top menu selection is same type tab as the foodSelectionChoices
      const foodSelectionChoicesArrayFiltered =
        foodSelectionChoicesArray.filter(
          (item) => item?.FoodMenuType_Id === TopMenuItemType
        );

      //check if there any exlcusive items already exist in the foodSelectionChoices of same type
      const foodSelectionChoicesArrayFilteredExclusive =
        foodSelectionChoicesArrayFiltered.filter(
          (item) => item?.FlagExclusiveMenuSelection === "1"
        );

      //if there is exclusive item we need to check if it belongs to the same menu TopMenuItem.Id
      const foodSelectionChoicesArrayFilteredExclusiveSameMenu =
        foodSelectionChoicesArrayFilteredExclusive.filter(
          (item) => item?.FoodMenu_Id === topMenuItem?.Id
        );

      //first check if there is selection with same type ?
      if (foodSelectionChoicesArrayFiltered.length > 0) {
        if (foodSelectionChoicesArrayFilteredExclusiveSameMenu.length > 0) {
          // if same menu id same type simple add item
          HelperSetFoodSelection();
          return;
        }
        // swapping from exclusive to non exclusive check:
        if (foodSelectionChoicesArrayFilteredExclusive.length > 0) {
          // if there is exclusive item of same type show popup
          HelperHandlePopUpAboutSwitchingMenu();
        } else {
          // so its same type and check if topmenuitem is exclusive
          if (TopMenuItemExclusive) {
            // if topMenuItem is exclusive show popup
            HelperHandlePopUpAboutSwitchingMenu();
            return;
          }
          // if no exclusive items of same type exist add item
          HelperSetFoodSelection();
        }
      } else {
        // if no items of same type exist add item
        HelperSetFoodSelection();
      }
    }
  };

  const handleFoodSelectionMaxNoOfChoices = (categoryItem, foodItem) => {
    // try to parce in if cant set as 0

    const maxNoOfChoices = parseInt(categoryItem?.MaxNoOfChoices) || 0;
    // use categorys activeMenuStarters, activeMenuMains, activeMenuSides, activeMenuDeserts check if foodItem.Product_Id is in any of them from foodSelectionChoices
    // if it is return true
    // else return false
    if (maxNoOfChoices === 0) return true;
    if (isEmpty(foodSelectionChoices)) return true;
    let Counter = {};
    // Dynamic Categories
    foodMenuSearchAPI?.foodmenu_list?.map((topMainMenuItem) => {
      topMainMenuItem?.Id === activeTab &&
        topMainMenuItem?.FoodMenuToFoodMenuCategory?.map(
          (categoryItem) =>
            (Counter = {
              ...Counter,
              [categoryItem?.FoodMenuCategory_Id]: 0,
            })
        );
    });

    // loop through foodSelectionChoices and count how many of each category
    Object.values(foodSelectionChoices).map((item) => {
      // use Dynamic Categories from Counter
      Counter[item?.FoodMenuCategory_Id] =
        Counter[item?.FoodMenuCategory_Id] + 1;
    });

    //using dynamic  categories from Counter
    return Counter[categoryItem?.FoodMenuCategory_Id] < maxNoOfChoices;
  };

  const [deleteSelectedfoodItem, setDeleteSelectedfoodItem] = useState(null);

  const functionRemoveSelectedChoiceFromMenu = () => {
    delete foodSelectionChoices[deleteSelectedfoodItem];
    setDeleteSelectedfoodItem(null);
    setDeleteSelectedChoiceModal(false);
  };
  // Task 24837 - take the whole line off in one click.
  //
  // Before this, clearing a dish you had set to 4 meant pressing minus four
  // times and then confirming a modal on the last one. Note the shape: a new
  // object, not a delete on the one in state. The existing
  // functionRemoveSelectedChoiceFromMenu mutates state in place and only
  // re-renders because closing its modal happens to set other state - that
  // is not a pattern to copy.
  const handleRemoveSelectionEntirely = (item) => {
    const next = { ...foodSelectionChoices };
    delete next[item?.Id];
    setFoodSelectionChoices(next);
  };

  const handleAddQuantityRemove = (item, addRemove) => {
    if (addRemove === "add") {
      setFoodSelectionChoices({
        ...foodSelectionChoices,
        [+item?.Id]: {
          ...foodSelectionChoices?.[+item?.Id],
          quantity: foodSelectionChoices?.[+item?.Id]?.quantity
            ? +foodSelectionChoices?.[+item?.Id]?.quantity + 1
            : 2,
        },
      });
    }
    if (addRemove === "remove") {
      if (+foodSelectionChoices?.[item?.Id]?.quantity == 1) {
        // delete foodSelectionChoices[item?.Id];
        setDeleteSelectedfoodItem([item?.Id]);
        setDeleteSelectedChoiceModal(true);
        setFoodSelectionChoices({ ...foodSelectionChoices });
      } else {
        setFoodSelectionChoices({
          ...foodSelectionChoices,
          [+item?.Id]: {
            ...foodSelectionChoices?.[item?.Id],
            quantity: +foodSelectionChoices?.[item?.Id]?.quantity - 1,
          },
        });
      }
    }
  };
  const [sortedData, setSortedData] = useState([]);
  useEffect(() => {
    if (isEmpty(foodMenuSearchAPI)) return;
    let data = [];
    foodMenuSearchAPI?.foodmenu_list?.forEach((item) => {
      if (activeTab === item?.Id || activeTab === "") {
        item?.FoodMenuToFoodMenuCategory?.forEach((categoryItem) => {
          const filteredFoodItems =
            categoryItem?.FoodItemToFoodMenuCategory?.filter((foodItem) => {
              // Allergen filter (exclusion)
              if (selectedAllergens.length > 0) {
                const foodItemAllergenIds =
                  foodItem.foodallergen_data?.map((fa) => fa.Id) || [];
                const hasAllergen = selectedAllergens.some((sa) =>
                  foodItemAllergenIds.includes(sa.value)
                );
                if (hasAllergen) {
                  return false;
                }
              }

              // Diet type filter (inclusion)
              if (selectedDietTypes.length > 0) {
                const foodItemDietTypeIds =
                  foodItem.fooddiettype_data?.map((fdt) => fdt.Id) || [];
                const matchesAllDietTypes = selectedDietTypes.every((sdt) =>
                  foodItemDietTypeIds.includes(sdt.value)
                );
                // If it doesn't match all selected diet types, filter it out
                if (!matchesAllDietTypes) {
                  return false;
                }
              }
              return true;
            }).sort((a, b) => a?.Order - b?.Order);

          data.push({
            ...categoryItem,
            FoodItemToFoodMenuCategory: filteredFoodItems,
          });
        });
      }
    });
    setSortedData(data);
  }, [
    foodMenuSearchAPI,
    activeTab,
    selectedAllergens,
    selectedDietTypes,
  ]);
  const [warningCustomerOfMenuChoice, setWarningCustomerOfMenuChoice] =
    useState(false);

  const toggle = () =>
    setWarningCustomerOfMenuChoice(!warningCustomerOfMenuChoice);

  const [tabId, setTabId] = useState("");
  const [currentTopMenuItem, setCurrentTopMenuItem] = useState(null);

  const handleCustomerChangeMenuTab = (topMenuItem) => {
    if (topMenuItem?.Id === activeTab) return;
    setActiveTab(topMenuItem?.Id);
  };

  const [deleteSelectedChoiceModal, setDeleteSelectedChoiceModal] =
    useState(false);

  const [bodyToSend, setBodyToSend] = useState(null);
  const [enableStripeCheckout, setEnableStripeCheckout] = useState(false);

  const handleEnableStripeCheckout = () => {
    setBodyToSend([
      {
        FoodPreOrderEventGuest_Id: manageGuestFoodOrders
          ? eventUserData.Id
          : eventUserData?.data?.FoodPreOrderEventGuest_Id,
        FoodMenu_Id: activeTab,
        choices: Object.values(foodSelectionChoices).map((item) => {
          return {
            FoodItemToFoodMenuCategory_Id: item?.Id,
            SpecialInstructions: item?.note,
            Quantity: item?.quantity ?? 1,
          };
        }),
        paymentmethod_data: [
          {
            PaymentMethod_Id: PaymentMethod_Id,
          },
        ],
      },
    ]);
    setEnableStripeCheckout(true);
  };

  useEffect(() => {
    if (!enableStripeCheckout) return;
    setEnableStripeCheckout(false);
  }, [foodSelectionChoices]);
  const CallBackAfterPaymentError = (data) => {
    toast.error(data?.message);
    setEnableStripeCheckout(false);
  };

  const handleClearItemsFromPreviousMenuSelection = () => {
    //filter out foodSelectionChoices item that matches the currentTopMenuItem?.Id
    const arrayFoodSelectionChoices = Object.values(foodSelectionChoices);

    // we want to filter out all items that are not the same id as the currentTopMenuItem?.Id
    const filteredFoodSelectionChoices = arrayFoodSelectionChoices.filter(
      (item) => item?.FoodMenuType_Id !== currentTopMenuItem?.FoodMenuType_Id
    );
    // after filtering out add tempfoodItem to filteredFoodSelectionChoices
    if (tempSelectedItem) {
      filteredFoodSelectionChoices.push(
        //format:
        //   ...item,
        //   FoodMenuCategory_Id: categoryItem?.FoodMenuCategory_Id,
        // quantity: 1,
        // FoodMenuType_Id: topMenuItem?.FoodMenuType_Id,
        // FlagExclusiveMenuSelection: topMenuItem?.FlagExclusiveMenuSelection,
        // FoodMenu_Id: topMenuItem?.Id,
        {
          ...tempSelectedItem,
          FoodMenuCategory_Id: currentTopMenuItem?.FoodMenuCategory_Id,
          quantity: 1,
          FoodMenuType_Id: currentTopMenuItem?.FoodMenuType_Id,
          FlagExclusiveMenuSelection:
            currentTopMenuItem?.FlagExclusiveMenuSelection,
          FoodMenu_Id: currentTopMenuItem?.Id,
        }
      );
    }
    // save back as object
    let newFoodSelectionChoices = {};
    filteredFoodSelectionChoices.map((item) => {
      newFoodSelectionChoices = {
        ...newFoodSelectionChoices,
        [item?.Id]: {
          ...item,
        },
      };
    });
    // set foodSelectionChoices to newFoodSelectionChoices
    setFoodSelectionChoices(newFoodSelectionChoices);
    // set activeTab to tabId
    setActiveTab(tabId);
    // close modal
    setWarningCustomerOfMenuChoice(false);
  };

  // Task 24837 - the MUI StyledBadge/cart icon that hung off the old menu
  // tab has gone; the pill carries its own count.

  const { foodAllergenListSuccessAPI } = useSelector((state) => ({
    foodAllergenListSuccessAPI:
      state.Products.foodAllergenList?.foodallergen_list,
  }));
  const { foodDietTypeListSuccessAPI } = useSelector((state) => ({
    foodDietTypeListSuccessAPI:
      state.Products.foodDietTypeList?.fooddiettype_list,
  }));

  useEffect(() => {
    // Task 24831 - THESE TWO WENT OUT WITH NO AUTH AT ALL, and that is what
    // logged Scoozi's guests out mid pre-order: both returned 401, and the
    // central handler in fetchAPI.js treats a 401 as a dead session - it
    // clears localStorage and hard-redirects to /login, a page the guest has
    // no account for. Every other call on this screen already passed the
    // token; these two were simply missed.
    dispatch(getFoodDietTypeList(params?.token ?? null));
    dispatch(getFoodAllergenList(params?.token ?? null));
  }, []);

  const allergenOptions = useMemo(
    () =>
      foodAllergenListSuccessAPI?.map((allergen) => ({
        value: allergen.Id,
        label: allergen.Name,
      })) || [],
    [foodAllergenListSuccessAPI]
  );

  // Task 24837 - the confirmation screen used to say "thank you" and nothing
  // else, so the only way to check what you had ordered was to click Update
  // and read it off the live menu - on a page that had already told you you
  // were done. foodSelectionChoices holds ids and quantities but no names, so
  // resolve them back against the unfiltered menu. Deliberately unfiltered:
  // the summary must show what was ordered even if a diet filter is on now.
  const confirmedSelection = useMemo(() => {
    const chosen = foodSelectionChoices ?? {};
    if (Object.keys(chosen).length === 0) return { courses: [], total: 0 };

    const courses = [];
    let total = 0;

    foodMenuSearchAPI?.foodmenu_list?.forEach((menuItem) => {
      menuItem?.FoodMenuToFoodMenuCategory?.forEach((categoryItem) => {
        const items = [];
        categoryItem?.FoodItemToFoodMenuCategory?.forEach((foodItem) => {
          const choice = chosen?.[foodItem?.Id];
          if (!choice) return;
          const quantity = +choice?.quantity || 1;
          total += (+foodItem?.PriceLocal || 0) * quantity;
          items.push({
            Id: foodItem?.Id,
            name: foodItem?.Product_Name,
            price: foodItem?.PriceLocal,
            quantity,
            note: choice?.note,
          });
        });
        if (items.length > 0) {
          courses.push({
            Id: categoryItem?.Id,
            name: categoryItem?.FoodMenuCategory_Name,
            items,
          });
        }
      });
    });

    return { courses, total };
  }, [foodSelectionChoices, foodMenuSearchAPI]);

  // Task 24837 - a guest needs telling when a filter is the reason the menu
  // looks short, so both the Clear button and the note below hang off this.
  const hasActiveFilters =
    selectedDietTypes?.length > 0 || selectedAllergens?.length > 0;
  const activeFilterCount =
    (selectedDietTypes?.length ?? 0) + (selectedAllergens?.length ?? 0);

  // Task 24837 - shut by default. Most guests want the menu, not the
  // filters, and open it was eating the top of the screen before a single
  // dish appeared. Collapsing it must not make a filter invisible, so the
  // header carries a count and the "some dishes are hidden" note below stays
  // on screen whether the panel is open or shut.
  const [showFilters, setShowFilters] = useState(false);

  const dietTypeOptions = useMemo(
    () =>
      foodDietTypeListSuccessAPI?.map((diet) => ({
        value: diet.Id,
        label: diet.Name,
      })) || [],
    [foodDietTypeListSuccessAPI]
  );

  return (
    <div className={"food-menu-main-section"}>
      {deleteSelectedChoiceModal && (
        <DeleteModal
          show={deleteSelectedChoiceModal}
          onCloseClick={() => {
            setDeleteSelectedChoiceModal(false);
          }}
          onDeleteClick={() => {
            functionRemoveSelectedChoiceFromMenu(deleteSelectedfoodItem);
          }}
          customText={
            "Are you sure you want to remove this item from your selection?"
          }
          customButtonText={"Yes, Remove it!"}
        />
      )}

      {warningCustomerOfMenuChoice && (
        <WarnCustomerOfMenuChoice
          modal={warningCustomerOfMenuChoice}
          setModal={setWarningCustomerOfMenuChoice}
          toggle={toggle}
          clickCallBack={handleClearItemsFromPreviousMenuSelection}
        />
      )}

      {foodAlreadySelectedUpdateSelection ? (
        <div className="guest-confirmed">
          {/* Task 24837 - was a bare h5, a sentence telling you to click the
              button directly beneath it, and a yellow btn-warning. Warning
              yellow on a success screen is simply the wrong signal, and the
              instruction was redundant next to its own button.
              Now: a tick, what you chose, and one quiet way back in. */}
          <div className="guest-confirmed__mark">
            <i className="ri-check-line" />
          </div>
          <h5 className="guest-confirmed__title">Your choices are in</h5>
          <p className="guest-confirmed__sub">
            The kitchen has your order. You can change it until food choices
            close.
          </p>

          {confirmedSelection?.courses?.length > 0 && (
            <div className="guest-confirmed__list">
              {confirmedSelection.courses.map((course) => (
                <div className="guest-confirmed__course" key={course?.Id}>
                  <div className="guest-confirmed__course-title">
                    {course?.name}
                  </div>
                  {course?.items?.map((item) => (
                    <div className="guest-confirmed__row" key={item?.Id}>
                      <span className="guest-confirmed__qty">
                        {item?.quantity}
                      </span>
                      <span className="guest-confirmed__item">
                        {item?.name}
                        {item?.note && (
                          <span className="guest-confirmed__note">
                            <i className="ri-sticky-note-line" />
                            {item.note}
                          </span>
                        )}
                      </span>
                      {item?.price && (
                        <span className="guest-confirmed__price">
                          £{(+item.price * item.quantity).toFixed(2)}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              ))}
              {confirmedSelection?.total > 0 && (
                <div className="guest-confirmed__total">
                  <span>Total</span>
                  <span>£{confirmedSelection.total.toFixed(2)}</span>
                </div>
              )}
            </div>
          )}

          <button
            type="button"
            className="guest-confirmed__change"
            onClick={() => {
              setFoodAlreadySelectedUpdateSelection(false);
            }}
          >
            <i className="ri-pencil-line" />
            Change my choices
          </button>
        </div>
      ) : (
        <div>
          {/* Task 24837 - the filters.
              They were two bare react-selects floating above the menu wearing
              "job-select2", an admin-grid class, so they inherited the back
              office look on a page a restaurant's guests see. They also gave
              no hint that they were optional, and nothing said when a filter
              was hiding dishes - a guest could think the menu was short.

              Now one quiet panel that reads as a tool rather than a form to
              fill in, with a count of what is hidden and one click to undo
              it. classNamePrefix lets the stylesheet reach inside the
              control instead of leaning on somebody else's theme. */}
          <div className="guest-filters mb-3">
            <div className="guest-filters__head">
              <button
                type="button"
                className="guest-filters__toggle"
                aria-expanded={showFilters}
                onClick={() => setShowFilters((open) => !open)}
              >
                <i className="ri-equalizer-line" />
                Filter the menu
                {activeFilterCount > 0 && (
                  <span className="guest-filters__count">
                    {activeFilterCount}
                  </span>
                )}
                <i
                  className={
                    showFilters ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                  }
                />
              </button>
              {hasActiveFilters && (
                <button
                  type="button"
                  className="guest-filters__clear"
                  onClick={() => {
                    setSelectedDietTypes([]);
                    setSelectedAllergens([]);
                  }}
                >
                  Clear filters
                </button>
              )}
            </div>
            <Row className={showFilters ? "guest-filters__body g-3" : "d-none"}>
              <Col md={6}>
                <Label className="guest-filters__label">
                  Show only dishes that are
                </Label>
                <Select
                  isMulti
                  options={dietTypeOptions}
                  value={selectedDietTypes}
                  onChange={setSelectedDietTypes}
                  placeholder="Any dietary option"
                  className="guest-select"
                  classNamePrefix="guest-select"
                  isClearable={true}
                />
              </Col>
              <Col md={6}>
                <Label className="guest-filters__label">
                  Hide dishes containing
                </Label>
                <Select
                  isMulti
                  options={allergenOptions}
                  value={selectedAllergens}
                  onChange={setSelectedAllergens}
                  placeholder="No allergens excluded"
                  className="guest-select"
                  classNamePrefix="guest-select"
                  isClearable={true}
                />
              </Col>
            </Row>
            {hasActiveFilters && (
              <div className="guest-filters__note">
                <i className="ri-eye-off-line" />
                Some dishes are hidden by your filters.
              </div>
            )}
          </div>
          {/* Task 24837 - the menu selector.
              Was nav-tabs-custom anchors with href="#", which with a single
              menu rendered as one lone underlined link that looked like a
              mistake, and which hung a MUI cart icon with a PURPLE badge off
              the tab when anything was chosen.
              Now pills, with the count of what you have picked from that menu
              shown plainly. One menu looks deliberate; several read as a
              choice. The count is the useful part of the old badge without
              the icon or the borrowed colour. */}
          {/* With a single menu there is nothing to choose between, so a
              dark pill just looks like a button that does nothing. Show it as
              the menu's name instead, and only switch to pills when there is
              a real choice to make. */}
          {foodMenuSearchAPI?.foodmenu_list?.length === 1 ? (
            <div
              className="guest-menu-name mb-4"
              style={{ fontFamily: branding?.PortalCssFontFamilyDivHeading }}
            >
              {foodMenuSearchAPI?.foodmenu_list?.[0]?.Name}
            </div>
          ) : (
          <div className="guest-menu-picker mb-4">
            {foodMenuSearchAPI?.foodmenu_list?.map((topMenuItem, index) => {
              const chosenCount = Object.values(foodSelectionChoices)?.reduce(
                (acc, item) =>
                  item?.FoodMenu_Id === topMenuItem?.Id
                    ? +acc + +item?.quantity
                    : +acc,
                0
              );
              return (
                <button
                  key={index}
                  type="button"
                  className={classnames("guest-menu-pill", {
                    "guest-menu-pill--active": activeTab === topMenuItem.Id,
                  })}
                  onClick={() => setActiveTab(topMenuItem.Id)}
                >
                  {topMenuItem.Name}
                  {chosenCount > 0 && (
                    <span className="guest-menu-pill__count">
                      {chosenCount}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
          )}

          <div className={"menu-content-body pt-1"}>
            <div>
              {foodMenuSearchAPI?.foodmenu_list?.map((topMenuItem, index) => (
                <div key={index}>
                  {topMenuItem.Id === activeTab && (
                    <div>
                      <div className={"d-flex justify-content-center  "}>
                        <span className={"text-muted pt-1 text-center p-2"}>
                          {topMenuItem?.Description}
                        </span>
                      </div>

                      <Masonry
                        // Task 24837 - a menu reads DOWN, not across. At
                        // three columns a dish name wrapped onto three lines
                        // and its description onto four, so every item looked
                        // like a paragraph instead of a thing you order.
                        breakpointCols={window.innerWidth > 992 ? 2 : 1}
                        className="my-masonry-grid p-2 border-rad rounded"
                        columnClassName="my-masonry-grid_column"
                      >
                        {/* array of JSX items */}
                        {sortedData?.map((categoryItem, index) => {
                          if (
                            categoryItem?.FoodItemToFoodMenuCategory?.length ===
                            0
                          )
                            return null;
                          return (
                            <div key={categoryItem?.Id + index}>
                              {/* Task 24837 - the course header is now
                                  typography and a rule, not a filled grey bar
                                  inside a bordered box inside the page card.
                                  A printed menu does not put its courses in
                                  boxes either. The venue's heading font is
                                  kept. */}
                              <div className="guest-menu-course">
                                <div
                                  className="guest-menu-course__title"
                                  style={{
                                    fontFamily:
                                      branding?.PortalCssFontFamilyDivHeading,
                                  }}
                                >
                                  {categoryItem?.FoodMenuCategory_Name}
                                </div>
                                <div>
                                {categoryItem?.FoodItemToFoodMenuCategory?.map(
                                  (foodMenuItem) => (
                                    <div
                                      className={
                                        "guest-menu-item" +
                                        (foodSelectionChoices?.[
                                          foodMenuItem?.Id
                                        ]
                                          ? " guest-menu-item--selected"
                                          : "")
                                      }
                                      key={foodMenuItem?.Id + "foodMenuItem"}
                                    >
                                      {/* Task 24837 - THE ROW IS THE BUTTON.
                                          There used to be a blue "Select"
                                          under every dish; on an 85-dish A La
                                          Carte that is 85 competing calls to
                                          action, and the thing a guest wants
                                          to tap is the food. The check fills
                                          in, which is how every ordering app
                                          behaves.

                                          Deselecting is always allowed even
                                          when the course is at its maximum -
                                          otherwise someone who picked wrongly
                                          would be stuck with it. */}
                                      <div
                                        className={
                                          "guest-dish" +
                                          (foodSelectionChoices?.[
                                            foodMenuItem?.Id
                                          ]
                                            ? " guest-dish--selected"
                                            : "") +
                                          (hideFoodSelectAndConfirm ||
                                          !(
                                            handleFoodSelectionMaxNoOfChoices(
                                              categoryItem,
                                              foodMenuItem
                                            ) ||
                                            foodSelectionChoices?.[
                                              foodMenuItem?.Id
                                            ]
                                          )
                                            ? " guest-dish--readonly"
                                            : "")
                                        }
                                        role={
                                          hideFoodSelectAndConfirm
                                            ? undefined
                                            : "button"
                                        }
                                        onClick={() => {
                                          if (hideFoodSelectAndConfirm) return;
                                          if (
                                            !handleFoodSelectionMaxNoOfChoices(
                                              categoryItem,
                                              foodMenuItem
                                            ) &&
                                            !foodSelectionChoices?.[
                                              foodMenuItem?.Id
                                            ]
                                          )
                                            return;
                                          handleFoodSelectionChoices(
                                            foodMenuItem,
                                            categoryItem,
                                            topMenuItem
                                          );
                                        }}
                                      >
                                        {!hideFoodSelectAndConfirm && (
                                          <span className="guest-dish__check">
                                            <i className="ri-check-line" />
                                          </span>
                                        )}
                                        <span className="guest-dish__main">
                                          <span className="guest-dish__top">
                                            <span className="guest-dish__name">
                                              {foodMenuItem?.Product_Name}
                                            </span>
                                            {foodMenuItem?.PriceLocal && (
                                              <span className="guest-dish__price">
                                                £{foodMenuItem?.PriceLocal}
                                              </span>
                                            )}
                                          </span>
                                          {foodMenuItem?.Product_Description && (
                                            <span className="guest-dish__desc d-block">
                                              {foodMenuItem.Product_Description}
                                            </span>
                                          )}
                                        </span>
                                      </div>
                                      {!hideFoodSelectAndConfirm && (
                                        <div
                                          className={
                                            "d-flex align-items-center justify-content-center"
                                          }
                                        >
                                          {/* Task 24837 - the Select / Remove
                                              button lived here. The dish row
                                              above is the control now; Add
                                              Note and the quantity stepper
                                              below are unchanged. */}
                                          {foodSelectionChoices?.[
                                            foodMenuItem?.Id
                                          ] && (
                                            <div>
                                              <span
                                                className={
                                                  "ms-1 guest-chip-btn"
                                                }
                                                onClick={() => {
                                                  //     find item in foodSelectionChoices and toggle showNote
                                                  //   also check if property showNote exists on first click set to true
                                                  //   else toggle
                                                  setFoodSelectionChoices({
                                                    ...foodSelectionChoices,
                                                    [foodMenuItem?.Id]: {
                                                      ...foodSelectionChoices?.[
                                                        foodMenuItem?.Id
                                                      ],
                                                      showNote:
                                                        foodSelectionChoices?.[
                                                          foodMenuItem?.Id
                                                        ]?.showNote
                                                          ? false
                                                          : true,
                                                    },
                                                  });
                                                }}
                                              >
                                                {
                                                  // Add Note / Hide Note
                                                  foodSelectionChoices?.[
                                                    foodMenuItem?.Id
                                                  ]?.showNote
                                                    ? "Hide Note"
                                                    : "Add Note"
                                                }
                                              </span>
                                            </div>
                                          )}
                                          {handleFoodSelectionMaxNoOfChoices(
                                            categoryItem,
                                            foodMenuItem
                                          ) &&
                                            foodSelectionChoices?.[
                                              foodMenuItem?.Id
                                            ] && (
                                              <div className={""}>
                                                <span
                                                  className={
                                                    "d-flex align-items-center mx-1"
                                                  }
                                                >
                                                  {" "}
                                                  <span
                                                    className={
                                                      "guest-step-btn cursor-pointer"
                                                    }
                                                    onClick={() => {
                                                      handleAddQuantityRemove(
                                                        foodMenuItem,
                                                        "remove"
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    -
                                                  </span>
                                                  <span className={"mx-1"}>
                                                    Qty:{" "}
                                                    {foodSelectionChoices?.[
                                                      foodMenuItem?.Id
                                                    ]?.quantity ?? 1}
                                                  </span>
                                                  <span
                                                    className={
                                                      "guest-step-btn cursor-pointer"
                                                    }
                                                    onClick={() => {
                                                      handleAddQuantityRemove(
                                                        foodMenuItem,
                                                        "add"
                                                      );
                                                    }}
                                                  >
                                                    +
                                                  </span>{" "}
                                                  {/* Task 24837 - straight
                                                      out, whatever the
                                                      quantity. Minus walks
                                                      down one at a time,
                                                      which is four clicks
                                                      and a modal to undo a
                                                      dish set to 4. */}
                                                  <span
                                                    className="guest-remove-btn cursor-pointer"
                                                    title="Remove this dish"
                                                    onClick={() => {
                                                      handleRemoveSelectionEntirely(
                                                        foodMenuItem
                                                      );
                                                    }}
                                                  >
                                                    <i className="ri-delete-bin-line" />
                                                    Remove
                                                  </span>
                                                </span>
                                              </div>
                                            )}
                                        </div>
                                      )}

                                      {
                                        //     if item is in foodSelectionChoices
                                        //     show note
                                        foodSelectionChoices?.[foodMenuItem?.Id]
                                          ?.showNote && (
                                          <div className={"w-100 p-1"}>
                                            <textarea
                                              className={"form-control w-100 "}
                                              rows={2}
                                              onChange={(e) => {
                                                setFoodSelectionChoices({
                                                  ...foodSelectionChoices,
                                                  [foodMenuItem?.Id]: {
                                                    ...foodSelectionChoices?.[
                                                      foodMenuItem?.Id
                                                    ],
                                                    note: e.target.value,
                                                  },
                                                });
                                              }}
                                              value={
                                                foodSelectionChoices?.[
                                                  foodMenuItem?.Id
                                                ]?.note
                                              }
                                            />
                                          </div>
                                        )
                                      }
                                    </div>
                                  )
                                )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Masonry>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {!hideFoodSelectAndConfirm && (
            <div className={"d-flex flex-column justify-content-center mb-4"}>
              {foodMenuSearchAPI?.foodmenu_list?.map((topMenuItem, index) => (
                <div className={"text-center py-2"} key={index}>
                  {topMenuItem?.Id === activeTab && (
                    <div>{topMenuItem?.TextFooter}</div>
                  )}
                </div>
              ))}
              {/*<div className={"text-center py-2"}>*/}
              {/*  <h5>Confirm Your Food Selection</h5>*/}
              {/*</div>*/}
              {enableStripeCheckout ? (
                <div className={"p-2"}>
                  <div className={"text-center"}>
                    <h5>
                      Please complete your payment to confirm your selection
                    </h5>
                  </div>
                  <div>
                    <StripeTakePayments
                      callBackAfterPaymentSuccess={
                        handleCreateUpdateFoodSelection
                      }
                      CallBackAfterPaymentError={CallBackAfterPaymentError}
                      PaymentMethod_Id={PaymentMethod_Id}
                      bodyToSend={bodyToSend}
                      loading={
                        foodPreOrderEventGuestToFoodMenuItemCreateLoading
                      }
                      token={params?.token}
                    />
                  </div>
                </div>
              ) : (
                <div className={"w-100 px-2"}>
                  {foodPreOrderEventGuestToFoodMenuItemCreateLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <button
                      type="button"
                      disabled={foodSelectionAPIConfirmed}
                      className={"btn btn-success w-100"}
                      onClick={() => {
                        handleEnableStripeCheckout();
                      }}
                    >
                      {foodAlreadySelectedUpdateSelection
                        ? "Update Selection"
                        : "Confirm Selection"}{" "}
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FoodMenuTab;
